export default {
  development: 'development',
  production: 'production',
};



// WEBPACK FOOTER //
// ./src/environment.js